import React from "react";
import { MDBCol, MDBRow } from "mdbreact";

import { AbsCheckBox } from "abs-ui-components";

const GlobalReportExport = ({ onClose }) => {
	const handleCancel = () => {
		onClose();
	};
	return (
		<>
			<h4 className="blod">Export</h4>
			<hr />
			<p>Please select the items to export</p>
			<hr />
			<MDBRow>
				<MDBCol md="12">
					<div>
						<AbsCheckBox
							slim={true}
							id="Sample Voyages"
							label="Sample Voyages"
							//future scope
							// checked={field.value}
							// handleChange={handleCheckboxChange(field)}
							// disabled={isRepliedCorrection}
						/>
					</div>
				</MDBCol>
			</MDBRow>
			<hr />
			<p>Export Verified reports to:</p>
			<MDBRow>
				<MDBCol md="6">
					<div>
						<AbsCheckBox
							slim={true}
							id="Excel"
							label="Excel"
							//future scope
							// checked={field.value}
							// handleChange={handleCheckboxChange(field)}
							// disabled={isRepliedCorrection}
						/>
					</div>
				</MDBCol>
				<MDBCol md="6">
					<div>
						<AbsCheckBox
							slim={true}
							id="THETIS XML"
							label="THETIS XML"
							// checked={field.value}
							// handleChange={handleCheckboxChange(field)}
							// disabled={isRepliedCorrection}
						/>
					</div>
				</MDBCol>
			</MDBRow>
			<hr />
			<MDBRow>
				<MDBCol md="3">
					<div>
						<AbsCheckBox
							slim={true}
							id="Review Letter"
							label="Review Letter"
							//future scope
							// checked={field.value}
							// handleChange={handleCheckboxChange(field)}
							// disabled={isRepliedCorrection}
						/>
					</div>
				</MDBCol>
				<MDBCol md="4">
					<div>
						<AbsCheckBox
							slim={true}
							id="Statement of Compliance (SoC)"
							label="Statement of Compliance (SoC)"
							//future scope
							// checked={field.value}
							// handleChange={handleCheckboxChange(field)}
							// disabled={isRepliedCorrection}
						/>
					</div>
				</MDBCol>
				<MDBCol>
					<div>
						<AbsCheckBox
							slim={true}
							id="GISIS XML"
							label="GISIS XML"
							//future scope
							// checked={field.value}
							// handleChange={handleCheckboxChange(field)}
							// disabled={isRepliedCorrection}
						/>
					</div>
				</MDBCol>
			</MDBRow>
			<hr />
			<div className="mt-5 mb-2">
				<div className="mt-3 corrections-save-cancel-btn-wrapper">
					<div className="d-flex justify-content-end">
						<button
							className="btn mr-2 enroll-submit-btn"
							type="submit"
						>
							Export
						</button>
						<button
							id="enroll_vessel_cancel_button"
							className="btn fleet-cancel-btn"
							type="button"
							onClick={handleCancel}
						>
							Cancel
						</button>
					</div>
				</div>
			</div>
		</>
	);
};

export default GlobalReportExport;
